/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const THEME_COLOR_INDIGO_HEX = "#3F51B5";
export const THEME_COLOR_PURPLE_HEX = "#9C27B0";
